export const initialStepsState = {
    identify: true,
    filters: false,
    criteria: false,
    preview: false,
    addAssets: false,
    filtersDynamic: false,
    classifyAssets: false,
};

export function stepsReducer(state, action) {
    switch (action.type) {
        case 'ENABLE_TAB':
            return {...state, [action.tab]: true};
        case 'DISABLE_TAB':
            return {...state, [action.tab]: false};
        case 'SET_ADD_ASSETS':
            return {...state, addAssets: action.payload};
        case 'SET_FILTERS_DYNAMIC':
            return {...state, filtersDynamic: action.payload};
        case 'SET_CLASSIFY_ASSETS':
            return {...state, classifyAssets: action.payload};
        default:
            return state;
    }
}

export const useStepsTabs = (dispatch, steps) => ({
    enableTab: (tab) => dispatch({type: 'ENABLE_TAB', tab}),
    disableTab: (tab) => dispatch({type: 'DISABLE_TAB', tab}),
    setAddAssets: (value) => dispatch({type: 'SET_ADD_ASSETS', payload: value}),
    setFiltersDynamic: (value) => dispatch({type: 'SET_FILTERS_DYNAMIC', payload: value}),
    setClassifyAssets: (value) => dispatch({type: 'SET_CLASSIFY_ASSETS', payload: value}),
    getCurrentSteps: () => steps
});